import useAsyncData from "../../../../../hooks/use-async-data";
import billingService from "../../../billings.service";
import BillingsOrderTaxiRailyDraft from "./billings-order-taxi-raily-draft";
import BillingsOrderTaxiRailyDraftParams from "./billings-order-taxi-raily-draft-params";

const useBillingsOrderTaxiRailyDraft = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<BillingsOrderTaxiRailyDraft | null>(null);

  const load = async (
    params: BillingsOrderTaxiRailyDraftParams,
    abortSignal: AbortSignal,
  ) => {
    setIsError(false);
    setIsLoading(true);

    try {
      const data = await billingService.getOrderTaxiRailyBillingsDraft(
        params,
        abortSignal,
      );

      setData(data);
    } catch {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useBillingsOrderTaxiRailyDraft;
